import { Component, OnInit } from "@angular/core";
import { ConfigptoService } from "../../services/configpto.service";
import { Icon } from "../../models/card-icon";
import swal from "sweetalert2";
import { Methods } from "../../shared/methods";

@Component({
  selector: "app-configpto",
  templateUrl: "./configpto.component.html",
  styleUrls: ["./configpto.component.css"],
})
export class ConfigptoComponent implements OnInit {
  public mtds: Methods = new Methods();
  iconEditMail: Icon = {
    icon: "schedule",
    title: "Config PTO",
  };

  // public mtds: Methods = new Methods();
  public identity;
  public token;
  public saving;
  public year: number;
  public hours: number;
  public list;
  public probationPeriod;
  public probation;
  public showEdit;
  public showEditPL;
  public textDone;
  public ptoHoursLimit;
  constructor(
    private _configpto: ConfigptoService // private _companylinkedService: CompanylinkedService, // private _route: ActivatedRoute, // private _router: Router, // private _internalLocationservice: InternalLocationservice,
  ) {}

  createPto() {
    this.saving = true;
    let json;
    json = {
      year: this.year,
      hoursPto: this.hours,
    };
    this._configpto.create(json).subscribe(
      (response) => {
        if (response.status == "success") {
          this.textDone = "A New Year of PTO Has Been Added";
          this.done();
        }
        return response;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
    this.getPto();
  }
  getPto() {
    this._configpto.list().subscribe(
      (response) => {
        return (this.list = response.data);
        // console.log(response.data)
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  getProbation() {
    this._configpto.probationalPeriod().subscribe(
      (response) => {
        // console.log(response.data.probationPeriod);
        this.ptoHoursLimit = response.data.ptoHoursLimit;
        if(this.ptoHoursLimit == '' || this.ptoHoursLimit == null)
          this.ptoHoursLimit = 'No Limit';
        return (this.probation = response.data.probationPeriod);
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  updatePTOHoursLimit() {
    let json;
    json = {
      ptoHoursLimit: this.ptoHoursLimit,
    };
    this._configpto.setptohourslimit(json).subscribe(
      (response) => {
        if (response.status == "success") {
          this.textDone = "PTO Hours Limit Updated";
          this.done();
          this.showEdit = false;
        }
        return response;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
    // this.getProbation();
  }
  updateProbation() {
    let json;
    json = {
      probationPeriod: this.probation,
    };
    this._configpto.updateProbation(json).subscribe(
      (response) => {
        if (response.status == "success") {
          this.textDone = "Probation Period Updated";
          this.done();
          this.showEdit = false;
        }
        return response;
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
    // this.getProbation();
  }
  showSwal() {
    swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
    
      showCancelButton: true,
     

      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
      confirmButtonText: "Yes, delete it!",
      buttonsStyling: false,
    });
  }
  deleted() {
    swal.fire({
      title: "Deleted!",
      text: "The year has been deleted",
   
    customClass:{
    confirmButton: 'btn btn-success'
            },
      buttonsStyling: false,
    });
  }
  done() {
    swal.fire({
      title: "Done",
      text: this.textDone,
   
    customClass:{
    confirmButton: 'btn btn-success'
            },
      buttonsStyling: false,
    });
  }
  removePto(id) {
    swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
    
      showCancelButton: true,
    

      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
      confirmButtonText: "Yes, delete it!",
      buttonsStyling: false,
    }).then(
      function (result) {
        if (result.value) {
          this._configpto.delete(id).subscribe(
            (response) => {
              if (response.status === "success") {
                this.deleted();
              }
              this.getPto();
              console.log(response);
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
          this.getPto();
        }
      }.bind(this)
    );
  }
  ngOnInit() {
    this.getPto();
    this.getProbation();
  }
}
